/* Copyright (c) 2023, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { MicrophoneState } from '../constants';

export enum StateNames {
    Start = 'Start',
    Stop = 'Stop',
    Initializing = 'Initializing',
    Muted = 'Muted',
    Unmuted = 'Unmuted',
    PermissionPending = 'PermissionPending',
    PermissionDenied = 'PermissionDenied',
    NoMicFound = 'NoMicFound'
}

export enum Actions {
    Initialize = 'Initialize',
    UnmuteMic = 'UnmuteMic',
    MuteMic = 'MuteMic',
    AwaitPermssion = 'AwaitPermssion',
    DenyPermission = 'DenyPermission',
    LookForMic = 'LookForMic',
    StopMic = 'StopMic'
}

export const StateToActionMap = new Map<MicrophoneState, Actions>([
    [MicrophoneState.Unmuted, Actions.UnmuteMic],
    [MicrophoneState.Muted, Actions.MuteMic],
    [MicrophoneState.PermissionPending, Actions.AwaitPermssion],
    [MicrophoneState.PermissionDenied, Actions.DenyPermission],
    [MicrophoneState.NoMicFound, Actions.LookForMic]
]);
